import { SvgIcon, useTheme } from '@mui/material';

export function LockStrongIcon() {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize="small">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 0.833496C7.23858 0.833496 5 3.07207 5 5.8335V7.50016H4.16667C3.24619 7.50016 2.5 8.24635 2.5 9.16683V16.6668C2.5 17.5873 3.24619 18.3335 4.16667 18.3335H15.8333C16.7538 18.3335 17.5 17.5873 17.5 16.6668V9.16683C17.5 8.24635 16.7538 7.50016 15.8333 7.50016H15V5.8335C15 3.07207 12.7614 0.833496 10 0.833496ZM13.3333 7.50016V5.8335C13.3333 3.99255 11.8409 2.50016 10 2.50016C8.15905 2.50016 6.66667 3.99255 6.66667 5.8335V7.50016H13.3333Z"
        fill={theme.palette.colors.content['positive-secondary']}
      />
    </SvgIcon>
  );
}
